import { hiveCloudLogoUrl } from '@hivecloud/design-system/assets'
import { useI18n } from '@/i18n'
import { cn } from '@/lib/utils'

export function Brand({ compact = false, className }: { compact?: boolean; className?: string }) {
  const { t } = useI18n()
  return (
    <span className={cn('flex min-w-0 items-center gap-2.5', className)}>
      <span className='flex size-9 shrink-0 items-center justify-center rounded-md bg-white p-1'>
        <img src={hiveCloudLogoUrl} alt={compact ? 'HiveCloud' : ''} className='h-full w-full object-contain' />
      </span>
      {!compact && (
        <span className='min-w-0 text-start'>
          <span className='block text-sm leading-5 font-semibold'>HiveCloud</span>
          <span className='block text-xs leading-4 text-muted-foreground'>{t('controlPlane')}</span>
        </span>
      )}
    </span>
  )
}
